type DateInput = Date | string | number | null | undefined;

export const GERMAN_TIME_ZONE = 'Europe/Berlin';
export const SCHEDULE_CONFLICT_TOLERANCE_MS = 60000;

export const toValidDate = (input: DateInput): Date | null => {
  if (!input) return null;
  const dateObj = input instanceof Date ? input : new Date(input);
  return Number.isNaN(dateObj.getTime()) ? null : dateObj;
};

export const parseScheduledAt = (input: DateInput): Date | null => {
  return toValidDate(input);
};

export const getGermanDateTime = (date: Date = new Date()): Date => {
  return new Date(date.toLocaleString('en-US', { timeZone: GERMAN_TIME_ZONE }));
};

export const isSameDayInGermanTimezone = (date1: Date, date2: Date): boolean => {
  const german1 = getGermanDateTime(date1);
  const german2 = getGermanDateTime(date2);

  return german1.getFullYear() === german2.getFullYear() &&
    german1.getMonth() === german2.getMonth() &&
    german1.getDate() === german2.getDate();
};

export const createGermanDateTimeFromParts = (params: {
  year: number;
  month: number;
  day: number;
  hours: number;
  minutes: number;
  seconds?: number;
}): Date => {
  const { year, month, day, hours, minutes, seconds = 0 } = params;
  const monthStr = String(month).padStart(2, '0');
  const dayStr = String(day).padStart(2, '0');
  const hoursStr = String(hours).padStart(2, '0');
  const minutesStr = String(minutes).padStart(2, '0');
  const secondsStr = String(seconds).padStart(2, '0');

  const dateStr = `${year}-${monthStr}-${dayStr}T${hoursStr}:${minutesStr}:${secondsStr}`;
  return new Date(dateStr + '+01:00');
};

export const getScheduledAtTime = (input: DateInput): number | null => {
  const date = parseScheduledAt(input);
  return date ? date.getTime() : null;
};

export const isWithinScheduleTolerance = (
  scheduledAt: DateInput,
  target: Date,
  toleranceMs: number = SCHEDULE_CONFLICT_TOLERANCE_MS
): boolean => {
  const scheduledDate = parseScheduledAt(scheduledAt);
  if (!scheduledDate) return false;
  return Math.abs(scheduledDate.getTime() - target.getTime()) < toleranceMs;
};

export const formatPublishDateFromGermanDateTime = (date: Date): string => {
  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${day}.${month}.${year}`;
};
